export const APP_USE_PROMOS = true;
export const APP_BASE_URL =
// "http://therapp-dev.s3-website-us-east-1.amazonaws.com";
"https://app.therapp.health";
export const APP_ENDPOINT_URL =
// "http://localhost:8080";
// "http://therapp-dev.eba-6n8stqf6.us-east-1.elasticbeanstalk.com";
"https://api.therapp.health";